const experimentConfig = {
  globalExperiment: {
    experimentId: 'Q4KMAh3BQ4qNUNsdMXdprg',
    running: true,
    loadingCover: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false,
        homepageNewDesign: false
      },
      1: {
        globalExperiment: true,
        homepageNewDesign: true,
        categoryPageBlocksB: true,
        shouldRemoveTags: true
      }
    }
  },
  csatSurveyExperiment: {
    experimentId: 'csat_survey',
    running: true,
    sites: [
      'themeforest',
      'codecanyon',
      'videohive',
      'graphicriver',
      'audiojungle'
    ],
    loadingCover: false,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variantsWeights: [9, 1],
    variants: {
      0: {
        canShowCSATSurvey: false
      },
      1: {
        canShowCSATSurvey: true
      }
    }
  },
  ipxFasterItemPageImages: {
    experimentId: '2Th20Gy6TLS-_00B5DGFGQ',
    running: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {},
      1: {},
      2: {}
    }
  },
  pathToPreview: {
    experimentId: 'tRdrmdwSStunZwdrJzaGsQ',
    running: false,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      '3docean',
      'videohive',
      'audiojungle'
    ],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {},
      1: {},
      2: {},
      3: {},
      4: {},
      5: {},
      6: {}
    }
  },
  ipx2a: {
    experimentId: 'KpbHvpNOQK2mqcFRtWzlAQ',
    running: false,
    sites: [
      '3docean',
      'audiojungle',
      'codecanyon',
      'graphicriver',
      'photodune',
      'themeforest',
      'videohive'
    ],
    loadingCover: false,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {},
      1: {},
      2: {}
    }
  },
  storefront: {
    experimentId: 'w9XbskG0TTyfmOLUwwnhFQ',
    running: true,
    sites: [
      '3docean',
      'audiojungle',
      'codecanyon',
      'graphicriver',
      'photodune',
      'themeforest',
      'videohive'
    ],
    loadingCover: false,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {},
      1: {}
    }
  }
}

export default experimentConfig
